import { Decoration_Type } from 'ricos-schema';
import { EmptyDecoration } from './empty-decoration.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class UnderlineDecoration {
  constructor(customStyle) {
    this.type = Decoration_Type.UNDERLINE;
    this.customStyle = customStyle;
  }
  static of(decoration) {
    if (decoration.type !== Decoration_Type.UNDERLINE) {
      throw new TypeError(`invalid decoration initializer ${decoration}`);
    }
    return new UnderlineDecoration(decoration.underlineData ? { textDecoration: "underline" } : {});
  }
  getDecoration() {
    var _a;
    return {
      type: this.type,
      underlineData: (_a = this.customStyle.textDecoration) == null ? void 0 : _a.toString().includes("underline")
    };
  }
  static fromCustomStyle(customStyle) {
    return new UnderlineDecoration(customStyle);
  }
  fromCustomStyle(customStyle) {
    return UnderlineDecoration.fromCustomStyle(customStyle);
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(decoration) {
    if (!(decoration instanceof UnderlineDecoration || decoration instanceof EmptyDecoration)) {
      throw new TypeError(`invalid merge decoration ${decoration}`);
    }
    const customStyle = __spreadValues(__spreadValues({}, this.customStyle), decoration.toCustomStyle());
    return new UnderlineDecoration(customStyle);
  }
}

export { UnderlineDecoration };
//# sourceMappingURL=underline-decoration.js.map
